/* eslint-disable no-console */
const SEARCH_HISTORY_KEY = 'sokhistorik'

// Stolen from https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
export const isStorageAvailable = (type) => {
  if (typeof window === 'undefined') {
    return false
  }

  let storage
  try {
    storage = window[type]
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}

export const cacheLocalStorageAvailable = () => {
  let isAvailable
  return () => {
    if (isAvailable === undefined) {
      isAvailable = isStorageAvailable('localStorage')
    }
    return isAvailable
  }
}

export const getHistoryFromStorage = () => {
  const isAvailable = window && cacheLocalStorageAvailable()
  if (isAvailable) {
    try {
      // TODO: await?
      const history = window.localStorage.getItem(SEARCH_HISTORY_KEY)
      const parsedHistory = JSON.parse(history)
      return parsedHistory || []
    } catch (e) {
      console.error(e)
      return []
    }
  }
  return []
}

export const setHistoryInStorage = (history) => {
  const isAvailable = window && cacheLocalStorageAvailable()
  if (isAvailable) {
    try {
      const historyString = JSON.stringify(history)
      // TODO: await?
      window.localStorage.setItem(SEARCH_HISTORY_KEY, historyString)
    } catch (e0) {
      console.error(e0)
      try {
        window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify([]))
      } catch (e1) {
        console.error(e1)
      }
    }
  }
}
